import type { Entity } from "@firecms/core";
import type { Event } from "../collections/events";
import type { Space } from "../collections/spaces";

type OpenSpace = (entity: Entity<Space>, accountId: string) => void;
type OpenEvent = (entity: Entity<Event>) => void;

let openSpaceImpl: OpenSpace | undefined;
let openEventImpl: OpenEvent | undefined;

export function registerWorkspaceNavigation(handlers: {
  openSpace: OpenSpace;
  openEvent: OpenEvent;
}): () => void {
  openSpaceImpl = handlers.openSpace;
  openEventImpl = handlers.openEvent;
  return () => {
    openSpaceImpl = undefined;
    openEventImpl = undefined;
  };
}

export function openSpaceFromEntity(
  entity: Entity<Space>,
  accountId: string
): void {
  if (!openSpaceImpl) {
    console.error("Workspace navigation is not registered");
    return;
  }
  openSpaceImpl(entity, accountId);
}

export function openEventFromEntity(entity: Entity<Event>): void {
  if (!openEventImpl) {
    console.error("Workspace navigation is not registered");
    return;
  }
  openEventImpl(entity);
}
